import type { QueryClient } from "@tanstack/react-query";
import { updateThreadSummary } from "@/payroll/pack-chat/thread-cache";
import type {
  IPackChatThreadDetail,
  IPackChatThreadDetailResponse,
  IPackChatThreadSummary,
  IPackChatThreadsResponse,
} from "@/payroll/pack-chat/types";
import { managedPackThreadKey, managedPackThreadsKey } from "./keys";

export const invalidateManagedPackThreadQueries = (
  queryClient: QueryClient,
  businessId: string | null,
  periodStart: string | null,
  threadId?: string,
) =>
  Promise.all([
    queryClient.invalidateQueries({
      queryKey: managedPackThreadsKey(businessId, periodStart),
      exact: true,
    }),
    ...(threadId
      ? [
          queryClient.invalidateQueries({
            queryKey: managedPackThreadKey(businessId, periodStart, threadId),
            exact: true,
          }),
        ]
      : []),
  ]);

export const updateManagedPackThreadListCache = (
  queryClient: QueryClient,
  businessId: string | null,
  periodStart: string | null,
  thread: IPackChatThreadSummary,
) => {
  queryClient.setQueryData<IPackChatThreadsResponse>(
    managedPackThreadsKey(businessId, periodStart),
    (current) => updateThreadSummary(current, thread),
  );
};

export const updateDetail = (
  queryClient: QueryClient,
  businessId: string | null,
  periodStart: string | null,
  threadId: string,
  update: (thread: IPackChatThreadDetail) => IPackChatThreadDetail,
) => {
  queryClient.setQueryData<IPackChatThreadDetailResponse>(
    managedPackThreadKey(businessId, periodStart, threadId),
    (current) => (current ? { thread: update(current.thread) } : current),
  );
};
